import { toast } from "react-toastify";
import ErrorUtils from "../../utils/ApiUtils/ErrorUtils";
import { useMutation, useQueryClient } from "react-query";
import { integrateServicePackTranslation } from "../../api/integrateServicePackTranslation";
import ExportTranslationCacheName from "../../utils/ExportTranslationCacheName";

export function useIntegrateServicePack(onSuccessCallback?: () => void) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: integrateServicePackTranslation,
    onSuccess: (response) => {
      toast.success("Integration started successfully");
      queryClient.invalidateQueries(ExportTranslationCacheName.getExportTranslation());
      if (onSuccessCallback) {
        onSuccessCallback();
      }
    },
    onError: (error) => {
      let errorMsg = ErrorUtils.getErrorMessage(error);
      toast.error(errorMsg);
      console.error("Error submitting form:", error);
    },
  });
}
